<!--  
  [ngClass]="this.item.isClicked() ? 'text-white' : 'gray'"
 class="btn"


-->
<a
  (click)="clickOnMe()"
  class="text-link"
  type="button"
  style="border: 0px"
  [ngClass]="{'clicked': item.canBeSelected() && item.isClicked() && item.getType() !== buttonType.COLOR, 
              'btn' : item.getType() !== buttonType.COLOR }"
>
  <div
    *ngIf="item.getType() === buttonType.COLOR"
  >
    <i
      class="btn btn-circle ml-1 mr-1"
      [class.circle-clicked]="item.canBeSelected() && item.isClicked()"
      [style.background-color]="
        item.getType() === buttonType.COLOR ? item.getColor() : null
      "
    ></i>
  </div>
  <div
    *ngIf="item.getType() === buttonType.ICON &&  item.getCurrentIcon()"
    [class.clicked]="item.canBeSelected() && item.isClicked()"
    class="pt-2"
  >
    <i class="{{ item.getCurrentIcon() }}" aria-hidden="true"></i>
  </div>
  <!-- <div
    *ngIf="item.getType() === buttonType.IMAGE"
    [class.clicked]="isClicked"
    class="pt-2"
  >
    <img style="max-width: 20px" [src]="assetUrl + item.getImage()" alt="" />
  </div> -->
  <div *ngIf="item.getFriendlyName()"  class="pb-1 pt-1">
    {{ item.getFriendlyName() }}
  </div>
</a>
